import platformUtils from './platformUtils';
import * as postMessage from './postMessage';
import {validate} from './validations/validation';
import {extendCompSchema} from './validations/compSchemas';

const compType = 'ConsentPolicy';

const consentPolicySchema = {
    onConsentPolicyChanged: {
        schemaType: ['function'],
        validations: {
            type: true
        }
    }
};

function getCurrentConsentPolicy() {
    const RGI = platformUtils.getRGI();
    const data = RGI.getConsentData();
    const {policyDetails} = data;
    return policyDetails;
}

function resetConsentPolicy() {
    return new Promise((resolve, reject) => {
        postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
            command: 'resetConsentPolicy',
            callback: (_, error) => {
                return error ? reject(error) : resolve();
            }
        });
    });
}

function setConsentPolicy(policy) {
    return new Promise((resolve, reject) => {
        postMessage.sendMessageToHost(postMessage.Intent.WIX_CODE_SITE_API, {
            command: 'setConsentPolicy',
            data: policy,
            callback: (policyDetails, error) => {
                return error ? reject(error) : resolve(policyDetails);
            }
        });
    });
}

function onConsentPolicyChanged(callback) {
    const isValid = validate({
        compType,
        functionName: 'onConsentPolicyChanged',
        dataToValidate: {onConsentPolicyChanged: callback}
    });
    if (!isValid) {
        return;
    }
    const RGI = platformUtils.getRGI();
    RGI.addOnConsentPolicyChangedCallback(callback);
}

function _getConsentPolicyHeader() {
    const RGI = platformUtils.getRGI();
    const data = RGI.getConsentData();
    const {policyHeaderObject} = data;
    return policyHeaderObject;
}

export default function createConsentPolicyApi() {
    extendCompSchema(compType, consentPolicySchema);
    return {
        getCurrentConsentPolicy,
        resetConsentPolicy,
        setConsentPolicy,
        onConsentPolicyChanged,
        _getConsentPolicyHeader
    };
}
